<template>

   <ion-page id="password-reset-page">
    <ion-content>

      <TopLine :style="styleTopline" :title="passwordResetTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

       <div :style="styleMiddle">

        <div v-if="hasError">
          <ion-item>
            <ion-label color="danger">
              {{ message }}
            </ion-label>
          </ion-item>
        </div>
        <div v-if="!hasError" >
          <ion-item>
            <ion-label>
              {{ message }}
            </ion-label>
          </ion-item>
        </div>

        <div v-if="showForm">

            <ion-item>
              <ion-label>
                <h3>
                  {{ translateEnglishWords("For Email") }}: {{ email }}
                </h3>
              </ion-label>
            </ion-item>

            <ion-item>
              <ion-input :label="passwordString" type="password" label-placement="fixed" 
                        :placeholder="passwordPlaceholderString" :value="password"
                        @ionInput="passwordInputChange">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-item>

            <ion-item>
              <ion-input :label="passwordString" type="password" label-placement="fixed" 
                        :placeholder="passwordPlaceholderString" :value="password2"
                        @ionInput="password2InputChange">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
              </ion-input>
            </ion-item>

            <ion-item>
              <ion-checkbox label-placement="end" @ionChange="resetCookie = !resetCookie" checked><span class="ion-text-wrap">{{ translatePhrase("Cancel any open sessions on other devices. (Not needed if you only forgot your password)") }}</span></ion-checkbox>
            </ion-item>
        </div>
      </div>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </ion-content>
    </ion-page>
</template>

<script setup>

  // https://stackoverflow.com/questions/35914069/how-can-i-get-query-parameters-from-a-url-in-vue-js

  import { IonLabel,IonCheckbox,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

  import TopLine from '@/components/TopLine.vue'
  import ToolBar from '@/components/ToolBar.vue'

  import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, 
      calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import { computed } from "@vue/reactivity"
  import { ref, watch } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { useGetData , generateErrorAlertText} from '@/composables/getData.js'
  import Explain from '@/components/Explain.vue'
  import { parseWordsSaid } from '@/composables/wordlistSupport.js'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()  
  const windowSizeStore = useWindowSizeStore()

  const passwordResetTitle = ref(translateEnglishWords("Password Reset"))
  const emailString = ref(translateEnglishWords("Email"))
  const passwordString = ref(translateEnglishWords("Password"))
  const passwordPlaceholderString = ref(translateEnglishWords("Enter password"))

  const isDark = ref(connectionStore.getDarkmode != "light")

  const wordlist = "command done reset mute listen"
  emit("word-list",wordlist)

  const wordlistTrigger = ref(0)

  const TOOLBAR_RESET = 0

  const toolbarElements = ref([
    { index : TOOLBAR_RESET, label : translateEnglishWords("Reset Password") ,disabled : false},
  ])

  const toolbarTrigger = ref(0)

  const explainTitle = ref("")
  const explainMessage = ref("")

const hasError = ref(false)
const message = ref("")
const verify = ref("")
const email = ref("")

const password = ref("")
const password2 = ref("")
const resetCookie = ref(false)

const showForm = ref(true)

const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
emit("mic-is-muted",microphoneIsMuted.value)

const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

var url_v = localStorage.getItem("url_v")
var url_e = localStorage.getItem("url_e")
if (url_v == null || url_e == null) {
  hasError.value = true
  message.value = "The necessary URL parameters aren't there. If this persists, please try the 2nd link in the reset email that directs you to the old Chessvis website."
}
else {
  hasError.value = false
  verify.value = url_v
  email.value = decodeURIComponent(url_e)
}

console.log("email",email.value)

watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

watch(() => windowSizeStore.getWindowSize, () => {
  styleToolbar.value = buildStyleToolbar(availableWidthHeight())
  styleTopline.value = buildStyleTopline(availableWidthHeight())
  styleMiddle.value = buildStyleMiddle(availableWidthHeight())
})

function passwordInputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password.value = value.trim()
  }

    function password2InputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password2.value = value.trim()
  }

  function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_RESET :
        processWords("command reset")
        break
    }
  }

  function processWords(text) {
    //console.log("text in Logoff ",text)
    const returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        emit("where-next","/")
        break
      case "reset" :
        doReset()
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore")
          return ["ignore",""];
        if (currentWord == "done" || currentWord == "mute" || currentWord == "listen")
          return [currentWord,""]
        if (currentWord == "reset")
          return ["reset",""]

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
  }

function processJsonResponse (json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
      message.value = generateErrorAlertText(json)
      hasError.value = true
      return;
  }

  switch (json['stat']) {
    case 'g' :
      message.value = translatePhrase("Password Reset. Please use the 'Login' screen with the new password.")
      showForm.value = false
      hasError.value = false
      toolbarElements.value[TOOLBAR_RESET].disabled = true

      break
    default :
      message.value = json['stat']
      hasError.value = true
      break;
  }
}

function doReset() {
  if (password.value == "") {
    message.value = translatePhrase("Please enter your password")
    return
  }
  if (password2.value != password.value) {
    message.value = translatePhrase("Passwords don't match")
    return
  }
  message.value = translatePhrase("resetting password") + "...."
  var formData = { 
    e : email.value , 
    v:verify.value, 
    p: password.value,
    reset_cookie : (resetCookie.value) ? "y" : "n"
  }
  //console.log("password reset formdata",formData)
  useGetData("process8a_password_reset.php", formData, processJsonResponse)
}



</script>

<style scoped>

</style>
